import { render } from "./collect.vue?vue&type=template&id=676d7068&scoped=true&ts=true"
import script from "./collect.vue?vue&type=script&lang=ts"
export * from "./collect.vue?vue&type=script&lang=ts"

import "./collect.vue?vue&type=style&index=0&id=676d7068&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676d7068"]])

export default __exports__